import { createRootRouteWithContext, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { AppShell } from "@/components/AppShell";
import { api, APIError } from "@/lib/api";

interface RouterCtx {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterCtx>()({
  beforeLoad: async ({ location, context }) => {
    if (location.pathname === "/login") return;
    try {
      await context.queryClient.fetchQuery({
        queryKey: ["me"],
        queryFn: api.me,
        staleTime: 30_000,
      });
    } catch (err) {
      if (err instanceof APIError && err.status === 401) {
        throw redirect({ to: "/login", search: { next: location.pathname } });
      }
      throw err;
    }
  },
  component: AppShellRoute,
});

function AppShellRoute() {
  // Subscribe to the router's location so this component re-renders on every
  // navigation (including programmatic navigate() after login).
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (pathname === "/login") return <Outlet />;
  return <AppShell />;
}
